import { getPhysician } from '@kikodacode/vbi-cares-api';
import { useQuery } from 'react-query';
import { fromApiBalance } from 'utils/participation';
import { axiosInstance } from './axiosConfig';
import { queryKeys } from './constants';

export interface useProviderLookupProps {
  id: number;
}

export const useProviderLookup = ({ id }: useProviderLookupProps) => {
  const { data } = useQuery(
    queryKeys.providerById(id),
    async () => {
      return getPhysician(id, axiosInstance);
    },
    {
      enabled: !!id,
    },
  );
  // Return the provider found
  if (!data?.data) {
    return { providers: undefined };
  }

  const participation = fromApiBalance({
    amountDue: data.data.amountDue,
    participating: data.data.participating,
  });

  return {
    providers: {
      id: data.data.physicianId.toString(),
      firstName: data.data.fullName.split(',')[1] ?? '',
      lastName: data.data.fullName.split(',')[0] ?? '',
      balance: participation.balance,
      amount: participation.amount,
      license: data.data.licenseNumber,
      statusId: +data.data.statusId,
      legalCanPay: data.data.legalCanPay,
      participating: participation.participating,
      participationLocked: participation.participationLocked,
      baseBalance: participation.baseBalance,
      pendingPaymentStatus: data.data.pendingPaymentStatus,
    },
  };
};
